import {
  SCHEDULE_GRID_HEADER_HEIGHT,
  getScheduleCanvasHeightPx,
  getScheduleCanvasWidthPx,
  getScheduleCourtGapPx,
  getScheduleEffectiveCourtWidthPx,
  getScheduleLaidOutRowHeightPx,
} from '../../../../../features/schedule/scheduleZoomBounds';
import { getScheduleZoomTier } from './ScheduleZoomContext';

export function applyScheduleZoomCssVars(
  el: HTMLElement,
  scale: number,
  columnWidth: number,
  courtCount: number,
  viewportWidth: number,
  slotCount: number
): void {
  const effectiveCourtWidth = getScheduleEffectiveCourtWidthPx(
    courtCount,
    columnWidth,
    viewportWidth
  );
  const slotHeight = `${getScheduleLaidOutRowHeightPx(scale)}px`;
  const gap = getScheduleCourtGapPx(effectiveCourtWidth);
  const zoomTier = getScheduleZoomTier(scale, effectiveCourtWidth);
  const vars: Record<string, string> = {
    '--slot-height': slotHeight,
    '--court-width': `${effectiveCourtWidth}px`,
    '--court-step': `${effectiveCourtWidth + gap}px`,
    '--scale-y': String(scale),
    '--header-height': `${SCHEDULE_GRID_HEADER_HEIGHT}px`,
  };

  for (const [key, value] of Object.entries(vars)) {
    el.style.setProperty(key, value);
  }
  el.dataset.zoomTier = zoomTier;

  const canvasWidth = getScheduleCanvasWidthPx(courtCount, effectiveCourtWidth);
  const canvasHeight = getScheduleCanvasHeightPx(slotCount, scale);
  el.style.width = `${canvasWidth}px`;
  el.style.height = `${canvasHeight}px`;

  el.querySelectorAll<HTMLElement>('.virtualCourtColumn').forEach((column) => {
    for (const [key, value] of Object.entries(vars)) {
      column.style.setProperty(key, value);
    }
    column.dataset.zoomTier = zoomTier;
  });

  el.querySelectorAll<HTMLElement>('.virtualTimeItem').forEach((item) => {
    item.style.setProperty('--scale-y', String(scale));
  });

  const courtArea = el.querySelector<HTMLElement>('.virtualCourtArea');
  if (courtArea) {
    const courtAreaWidth = courtCount * (effectiveCourtWidth + gap);
    courtArea.style.height = `${canvasHeight}px`;
    courtArea.style.width = `${courtAreaWidth}px`;
  }

  const timeAxis = el.querySelector<HTMLElement>('.virtualTimeAxis');
  if (timeAxis) {
    timeAxis.style.height = `${canvasHeight}px`;
  }
}
